module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "restore-password"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Set New Password")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Welcome " + _vm._s(_vm.customer.first_name) + " " + _vm._s(_vm.customer.last_name) + "! You can now restore your password.\n          ")]), _vm._v(" "), (_vm.topMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.topMessage))])]) : _vm._e(), _vm._v(" "), (_vm.topError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.passwordError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.password_confirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password Confirmation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_confirmation),
      expression: "password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password Confirmation"
    },
    domProps: {
      "value": (_vm.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_confirmation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setNewPassword($event)
      }
    }
  }, [_vm._v("Restore")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2942cb18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/set-password.vue
// module id = 546
// module chunks = 1